<template>
  <div class="datepicker">
    <select
      title="연도 선택"
      :style="{width}"
      :value="selectedDateText"
      @change="onChangeYear"
    >
      <option v-for="item in optionsList" :value="item" :key="item">{{item}}년</option>
    </select>
  </div>
</template>

<script>
import datepicker from "$mixins/datepicker";

export default {
  mixins: [datepicker],
  props: {
    width: {
      type: String
    },
    format: {
      type: String,
      default: "yyyy"
    }
  },
  data() {
    return {
      selectedDate: this.value
    };
  },
  computed: {
    optionsList() {
      return _.times(this.maxYear - this.minYear + 1, i => this.maxYear - i);
    },
    selectedDateText() {
      return this.$utils.dateformat(this.selectedDate, this.format);
    },
    selectedStartDate() {
      return new Date(this.selectedDate.getFullYear(), 0, 1);
    },
    selectedEndDate() {
      const endDate = new Date(
        this.selectedDate.getFullYear(),
        11,
        31,
        23,
        59,
        59,
        999
      );
      return endDate;
    }
  },
  methods: {
    onChangeYear(e) {
      const date = new Date(this.selectedDate);
      date.setFullYear(parseInt(e.target.value), 10);
      this.selectedDate = date;
    },
    // 시작일 리턴
    getDate() {
      return this.getData().startDate;
    },
    getData() {
      return {
        value: this.selectedDateText,
        startDate: new Date(this.selectedStartDate),
        endDate: new Date(this.selectedEndDate)
      };
    }
  }
};
</script>
